<template>
    <div class="frmhozzatartozok_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>


        <div class="frmhozzatartozok_cont" v-show="(InitDone)&&(LIST.length>0)">
            <div v-for="(item, index) in LIST" :key="index" class="frmhozzatartozok_item">
                <div class="frmhozzatartozok_itemcol1">
                    <b>{{item.Nev}}</b>
                </div>
                <div class="frmhozzatartozok_itemcol2">
                    {{item.RokonsagiFok}}
                </div>
            </div>
        </div>

        <div class="frmhozzatartozok_cont" v-show="(InitDone)&&(LIST.length==0)" v-html="infotext_nincs_rekord">

        </div>



    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'


export default {
  name: 'frmhozzatartozok',
  components: {
      GrcText,
      GrcNum,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmhozzatartozok_",

          InitDone:false,  
          LIST:[],

          infotext_nincs_rekord:"",

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmhozzatartozok", pCompName);
    },

    SetLang()
    {
        this.infotext_nincs_rekord = this.GetTextBookItem("infotext_nincs_rekord");
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.LIST = Q.RESULT;

        this.InitDone = true;

      },

    async ShowLoginError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


